import { useWriteContract } from 'wagmi'

import wrappedEthAbi from '@src/contract/abi/wrappedEth.abi.json'
import { useWaitForTransaction } from '@src/hooks/useWaitForTransaction'

export const useWithdrawWeth = () => {
    const { writeContractAsync } = useWriteContract()
    const { waitForTransactionReceipt } = useWaitForTransaction()

    const withdrawWeth = async (address?: string, amount?: bigint) => {
        if (!address || !amount) {
            throw new Error('Address and amount are required')
        }

        return await writeContractAsync({
            abi: wrappedEthAbi,
            address: address as `0x${string}`,
            functionName: 'withdraw',
            // Note that 'withdraw' takes a single parameter: the amount of WETH to convert to ETH
            args: [amount],
        })
    }

    const waitForWithdraw = async (hash: string, chainId?: number) => {
        // Pass the chainId parameter to waitForTransactionReceipt
        await waitForTransactionReceipt(hash, false, false, chainId)
    }

    return {
        withdrawWeth,
        waitForWithdraw,
    }
}
